export const BlockStatus = {
  FINISHED: 'FINISHED',
  NOT_STARTED: 'NOT_STARTED',
  WAITING: 'WAITING',
  REJECTED: 'REJECTED',
};
